import { ApplicationContext } from '@upside/spa-shared-context';

import { appHeaderAppName, basePaths } from 'shell/const';
import { getAppStatus, registerApplication, LifeCycles } from 'single-spa';

import application from '../application';

/**
 * Registers appheader if the local storage feature flag globalheader is not set
 */
export default (context: ApplicationContext): void => {
  const localFeatureFlags = JSON.parse(
    localStorage.getItem('featureflagsmap') ?? '{}',
  ) as Record<string, string>;
  if (
    getAppStatus(appHeaderAppName) ||
    localFeatureFlags['feature-flag_show_global_header'] === 'true'
  ) {
    return;
  }
  registerApplication({
    activeWhen: () => context.authentication.loggedIn,
    app: () => System.import(appHeaderAppName) as Promise<LifeCycles>,
    name: appHeaderAppName,
    customProps: {
      basePath: basePaths[application.name],
      context,
      domElementGetter: () => document.querySelector('#app-header'),
    },
  });
};
